










import { defineComponent, useFetch, useMeta } from '@nuxtjs/composition-api'
import { useContent } from '~/composables/useContent'
import { useHomeSchemaScript } from '~/composables/useSchemaScript'

export default defineComponent({
  name: 'PagesHome',

  setup() {
    const { article, ensureContent } = useContent()
    const { homeSchemaScripts, setHomeSchemaScript } = useHomeSchemaScript()

    useFetch(async () => {
      await ensureContent()
      setHomeSchemaScript({
        title: article.value?.title ?? '',
        // mock data below
        phoneNumber: '+32 3 375 70 90',
      })
    })

    useMeta(() => {
      return homeSchemaScripts.value.length
        ? {
            script: homeSchemaScripts.value,
          }
        : {}
    })
  },

  head: {},
})
